// classStatusItem.js
export default class classStatusItem {
  constructor() {
    this.DealName     = null;
    this.ScenatioName = null;
    this.Result       = null;
  }
}